import { combineReducers } from "redux";

import { resturantsDetails } from "./reducer.resturants"
const resturantsReducers = combineReducers({
  resturantsDetails
})
export default resturantsReducers;
